import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 h-[400px] flex flex-col relative overflow-hidden" }
const _hoisted_2 = { class: "flex items-center justify-between mb-6 flex-shrink-0" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "text-lg font-bold text-slate-800 dark:text-slate-100" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = {
  key: 0,
  class: "absolute top-full right-0 mt-2 w-48 bg-white dark:bg-[#0c1427] border border-gray-200 dark:border-[#172036] rounded-md shadow-lg z-10"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex-1 min-h-0 relative w-full overflow-hidden" }
const _hoisted_9 = {
  key: 0,
  class: "flex justify-center items-center h-full w-full absolute inset-0"
}
const _hoisted_10 = { class: "flex flex-col items-center gap-4" }
const _hoisted_11 = { class: "text-sm font-medium text-slate-600 dark:text-slate-400" }
const _hoisted_12 = {
  key: 1,
  class: "w-full h-full relative"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "w-10 h-10 rounded-xl bg-gradient-to-br from-purple-400 to-purple-600 dark:from-purple-500 dark:to-indigo-600 flex items-center justify-center shadow-lg" }, [
          _createElementVNode("svg", {
            class: "w-6 h-6 text-white",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2-2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            })
          ])
        ], -1)),
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.directT('dashboard.crm.balanceOverview')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["stop"])),
          class: _normalizeClass(["inline-flex items-center gap-2 px-4 py-2.5 text-sm font-semibold bg-white dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-xl hover:bg-gray-50 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 transition-all duration-300 shadow-sm hover:shadow-md focus:ring-2 focus:ring-violet-500/20", { 'ring-2 ring-violet-500/20': _ctx.isActive }])
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.getPeriodLabel()), 1),
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["w-4 h-4 transition-transform duration-200", { 'rotate-180': _ctx.isActive }]),
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M19 9l-7 7-7-7"
            }, null, -1)
          ]), 2))
        ], 2),
        (_ctx.isActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([
              { key: 'week', label: _ctx.directT('dashboard.thisWeek') },
              { key: 'month', label: _ctx.directT('dashboard.thisMonth') },
              { key: 'year', label: _ctx.directT('dashboard.thisYear') }
            ], (period) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: period.key,
                  type: "button",
                  onClick: ($event: any) => (_ctx.setPeriod(period.key as any)),
                  class: _normalizeClass(["w-full text-left px-4 py-2.5 text-sm font-medium text-slate-700 dark:text-slate-200 hover:bg-violet-50 dark:hover:bg-violet-900/20 transition-colors duration-200 flex items-center gap-2", { 'bg-violet-100 dark:bg-violet-900/30 text-violet-700 dark:text-violet-300': _ctx.selectedPeriod === period.key }])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-2 h-2 rounded-full", _ctx.selectedPeriod === period.key ? 'bg-violet-500' : 'bg-transparent'])
                  }, null, 2),
                  _createTextVNode(" " + _toDisplayString(period.label), 1)
                ], 10, _hoisted_7))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "w-16 h-16 border-4 border-violet-200 dark:border-violet-800 border-t-violet-500 dark:border-t-violet-400 rounded-full animate-spin" }, null, -1)),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.directT('general.loading')) + "... ", 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_ctx.isClient)
              ? (_openBlock(), _createBlock(_component_apexchart, {
                  key: 0,
                  type: "area",
                  height: "280",
                  class: "w-full",
                  options: _ctx.balanceOverview,
                  series: _ctx.overview
                }, null, 8, ["options", "series"]))
              : _createCommentVNode("", true)
          ]))
    ])
  ]))
}